import * as React from "react";

import primaryColour from "../../constants";

function SvgIgnitionoff(props: React.SVGProps<SVGSVGElement>) {
  const { fill = primaryColour } = props;
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M20.4507 6.65104L16.699 10.4027L19.498 10.4027L21.398 12.1127L18.738 14.2027L17.598 13.0627L16.458 14.2027L15.318 13.0627L14.178 14.2027L12.899 14.2027L6.65104 20.4507C6.08137 20.0894 5.55074 19.672 5.06689 19.2064L19.2064 5.06689C19.672 5.55074 20.0894 6.08137 20.4507 6.65104Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.90797 8.31271C9.32506 8.31271 10.5702 9.0531 11.2781 10.1667L5.77163 15.6732C4.65739 14.9655 3.91797 13.7204 3.91797 12.3027C3.91797 10.0991 5.70436 8.31271 7.90797 8.31271ZM5.43799 12.3027C5.43798 11.6731 5.94838 11.1627 6.57799 11.1627C7.20758 11.1627 7.71798 11.6731 7.71797 12.3027C7.71798 12.9323 7.20758 13.4427 6.57799 13.4427C5.94838 13.4427 5.43798 12.9323 5.43799 12.3027Z"
        fill={fill}
      />
    </svg>
  );
}

export default SvgIgnitionoff;
